
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Công cụ này cho phép bạn sửa danh sách thành phần. Bạn có thể thêm, xóa hoặc chỉnh sửa danh sách thành phần
                .
                <br>
                Ký tự này <span class="highlight">␣</span> biểu thị một khoảng trắng.
                <br>
                Ký tự này <span class="highlight">↩︎</span> biểu thị một ngắt dòng. `,
'hb28f1f2ec1744ee9': html`Các thuộc tính này được người dùng tạo và lưu trữ cho mọi mục đích sử dụng. Vui lòng
                    tự do thêm thuộc tính của riêng bạn. Các thuộc tính và giá trị bạn tạo
                    <strong>phải là thông tin thực tế</strong>. Bạn có thể xem
                    <a href="${0}">danh sách các thuộc tính đã được cộng đồng sử dụng</a>
                    hoặc khám phá tài liệu thuộc tính
                    <a href="${1}">và công cụ tìm kiếm</a>.`,
's000a5b76bd3a01c2': `Đang tải thuộc tính...`,
's000d98595e959c1e': `Lấy nó từ Google Play`,
's013bdc8cf0d3583d': `Giúp chúng tôi về thành phần`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Xác thực cây trồng`,
's03e9c8114521b998': `Tôi sẽ chỉnh sửa các thành phần`,
's05ec315d9308091a': `Biểu tượng góc mã vạch`,
's061eb5af92512c85': `Đã lưu! Bạn có thể giúp tôi thêm một cái nữa không?`,
's06847c221c4c0bc1': `Tôi muốn tạo một thuộc tính để [mô tả trường hợp sử dụng của bạn]...`,
's06f6c6f99db6b552': `Nguyên bản`,
's081e2ad82db71e1d': `Giá trị nhóm`,
's09205907b5b56cda': `Không`,
's0b4235aae602a950': `tài liệu chuyên dụng`,
's0bb2d48532acc455': `Tải xuống CSV`,
's0d5b7fee0311db68': `Tài sản`,
's0fb218abc2e157ed': `Làm mất hiệu lực hình ảnh`,
's100c4928cc74642a': `Hỗ trợ sự phát triển của nghiên cứu y tế công cộng.`,
's10db5498186c083b': `Hủy bỏ cắt xén`,
's11a18a69b30b65ed': `Giúp chúng tôi sửa lỗi trong danh sách thành phần`,
's1205d5f6fccf8e69': `Giá trị tài sản`,
's15d64a0a6715285a': `Chìa khóa mới`,
's166bd56d19670a72': `Thu phóng`,
's19059bf0c4f7c162': `Khu vực lựa chọn`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Hãy giúp chúng tôi sửa thông tin dinh dưỡng`,
's1e00019dc454872d': `Vui lòng cung cấp tên thuộc tính bằng cách sử dụng thuộc tính property-name.`,
's1e49126af0935a5b': `Danh sách các sản phẩm sử dụng thuộc tính này`,
's21e73088de6f26f3': `Tải về trên App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Huỷ`,
's2db7b654c0a9bde0': `Tài liệu về tài sản`,
's300b3a6ee4e1252d': str`Trận đấu kém ${0}%`,
's33f786bb6b4f0cf4': `Kết quả cắt xén`,
's33f85f24c0f5f008': `Lưu`,
's34be4af4e8fec4ae': `Hãy hỏi cộng đồng trước`,
's36d86adc823cbfa6': `Trước khi tạo một thuộc tính mới, hãy thảo luận với cộng đồng:`,
's3781d25aa51a736c': `Tài liệu về Công cụ Folksonomy`,
's383ae4449428b61e': `Đặt lại cây trồng`,
's39bcf88721a1e8ee': `Đặt lại lựa chọn`,
's39e14e14300694c7': `Tài liệu và Hướng dẫn`,
's3b430cfa5c1fe7f4': str`Tài liệu cho ${0}`,
's3f4e4b52f230a892': `Hình ảnh vải bạt`,
's417b90913e05bc17': `Xem trước`,
's41f7dca46d3f1b4a': `Giá trị`,
's422bba9636ce2489': `Hình ảnh trung tâm`,
's42dd66b2441566fd': `Biểu tượng trung tâm`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Thêm chất dinh dưỡng`,
's453ab0dbb9b5c777': `Thay đổi kích thước phải`,
's475b08749d0706ed': `Hãy giúp chúng tôi cung cấp thông tin cho hàng triệu người tiêu dùng trên toàn thế giới về những gì họ ăn.`,
's49730f3d5751a433': `Đang tải...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Số lượng sản phẩm`,
's4df2f533c0c1e7d0': `Kiểm soát hình ảnh`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Di chuyển lựa chọn`,
's4f751fb9b3ed766c': `Tạo một thuộc tính mới`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Nhập tên tài sản...`,
's55d7249883a98ca1': `về tài sản này trên wiki Open Food Facts`,
's565867d84c04aea2': `Thuộc tính bộ lọc...`,
's5666afe5cd0166de': `Vui lòng sửa lỗi hoặc chỉnh sửa văn bản trước khi xác nhận`,
's57472465a23b41db': `Giá trị`,
's58e1eeea7a60ae51': `Đang tải sản phẩm...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Hãy giúp chúng tôi sửa thông tin dinh dưỡng.`,
's5dd6f12783fca34f': `Chỉnh sửa danh sách thành phần`,
's5e8250fb85d64c23': `Đóng`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `TÔI ỦNG HỘ`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Chỉnh sửa`,
's66413c24dcf680e2': `Bỏ qua`,
's67ae6594857a4d57': `Cảm ơn sự đóng góp của bạn!`,
's6cee7cad81dfedd1': `Hình ảnh đã cắt`,
's6d7b6cdedaadfb6e': `Mỗi đóng góp đều có ý nghĩa! Chúng tôi trân trọng sự hỗ trợ của bạn trong việc thúc đẩy tính minh bạch về thực phẩm trên toàn thế giới.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Phù hợp tốt ${0}%`,
's71a5c9f4b68ef4d4': `Đếm`,
's74cb3d66f6a668e1': `Tài liệu`,
's787dd11bed0dc88a': `Thay đổi kích thước bên trái`,
's7ce4fd9430e80cea': `giá trị`,
's801a05fa8e881f37': `Tìm hiểu thêm về việc tạo tài sản và hướng dẫn:`,
's8038273de2cf8b73': `Vui lòng chọn vùng để cắt.`,
's839cc2908a5387f2': `Lọc mã vạch...`,
's86197dcf3e96af64': `Duyệt và tìm kiếm các bất động sản hiện có`,
's8a63be30a129a59c': `Thay đổi kích thước dưới cùng`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Thay đổi kích thước góc trên bên phải`,
's8db84aa4bc949af2': `Tài liệu về Bất động sản mới`,
's8f839a03997a16d7': `Xem sản phẩm`,
's901ae1e236ac45d3': `Hủy xóa`,
's907f7a97c6b29425': `Xin lưu ý rằng mô hình dữ liệu có thể bị thay đổi. Sử dụng theo rủi ro của riêng bạn.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Thành phần :`,
's9a7f60fce090ecaf': `Không tải được thuộc tính. Vui lòng thử lại sau.`,
's9b87abd68fb9df45': `Không tìm thấy? Tạo khóa mới {value}`,
's9c0f52425fd2f07e': `Có thể không khớp`,
's9fc41f789c63b40d': `Sản phẩm`,
'sa1fa766e0d5634d7': `Không có điểm số`,
'sa548778b24054030': `Khám phá tất cả các thuộc tính được đóng góp từ dự án Folksonomy Engine. Các thuộc tính này cung cấp thêm siêu dữ liệu và thông tin chi tiết về các sản phẩm trong cơ sở dữ liệu Open Food Facts.`,
'sa63907958bd0ec4b': `Thay đổi kích thước góc trên bên trái`,
'sa95b4224f685a36a': `Đóng cửa sổ`,
'sab56a1d439576fd6': `Biểu tượng gợi ý`,
'sac47ea2901d04c15': `Thay đổi kích thước góc dưới bên trái`,
'sb125227d436c2925': `Tìm kiếm khái niệm bất động sản của bạn trong cơ sở dữ liệu bất động sản hiện có:`,
'sb125568d43642e6f': `Trả lời các câu hỏi về sản phẩm.`,
'sb1c538e038f9b214': str`Rất phù hợp ${0}%`,
'sb28639570ff3b852': `danh sách tất cả các thuộc tính`,
'sb3bdd638a58d30f4': `Thu hút một cộng đồng công dân tận tâm,`,
'sb3cbcc1bd0fff140': `Sau khi bạn đã xác minh rằng tài sản của mình không tồn tại và cộng đồng đồng ý rằng nó hữu ích, trước tiên bạn cần ghi lại tài sản đó trên wiki.`,
'sb3d4f79d9d8b71e5': `Gửi`,
'sb560fa37a7bfb6c2': `Không tìm thấy sản phẩm nào cho thuộc tính này.`,
'sb7f72e4c8a2d3357': `Lọc giá trị...`,
'sb8178320160f84ea': `Hiển thị cây trồng`,
'sbad7d2734149470b': `Xác thực`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Mọi thắc mắc đã được giải đáp! Cảm ơn sự giúp đỡ của bạn!`,
'sbd9a0b2293b3cd3c': `Kích thước phục vụ`,
'sbe472dc3c2685985': `Giá trị tương ứng`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Thay đổi kích thước đầu trang`,
'sc1c08d0cbcc3bd24': `Không khớp`,
'sc52696641af72b53': `Cài đặt ứng dụng!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Đề xuất sửa chữa`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Di chuyển hình ảnh`,
'sc895972c88d38ca5': `Tài sản dân gian`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Hàng`,
'scb3b0671d7b7f640': `Giá trị mới`,
'scb489a1a173ac3f0': `Có`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Tham gia thảo luận trên Slack`,
'scdb6cad0b92721bf': `Không tìm thấy bất động sản nào.`,
'scf23a05631f93732': `Xác nhận xóa`,
'scfed2f270ef6a3aa': `Chọn khu vực`,
'sd1022bc1ef9204f7': `Hình ảnh có thể phóng to`,
'sd1077c055cf9ba6b': `Hãy giúp chúng tôi xác thực danh sách thành phần của sản phẩm.`,
'sd698d21ddecba56b': `Xin chào! Bạn có thể giúp chúng tôi cải thiện thông tin sản phẩm bằng cách trả lời các phần sau:`,
'sd82bc2decefa621b': `vẫn độc lập với ngành công nghiệp thực phẩm,`,
'sdb97e5976482606e': `Kiểm tra xem một thuộc tính đã tồn tại chưa`,
'sdbf806fefc584115': `Bạn nên tìm một`,
'sdc673e73b5c13aea': `Xóa`,
'sdc792b75f1edcaba': `Hãy giúp chúng tôi sửa lỗi chính tả của thành phần.`,
'sdca5deead576ceee': `Thay đổi kích thước góc dưới bên phải`,
'sdcc2555c5dde524f': `Bạn có chắc chắn muốn xóa mục này không? Thao tác này không thể hoàn tác.`,
'se206feec7ec57b28': `mỗi 100g`,
'se419a9ab36987490': `Làm mất hiệu lực`,
'se5127cf0f92e7e48': `Mẹo: bạn cũng có thể tìm thấy`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Tôi sẽ đề xuất một vụ mùa tốt hơn`,
'seea3800e27baa686': `Sản phẩm riêng lẻ`,
'sefaba4adc4ec9219': `Thuộc tính Folksonomy`,
'seffa8ca49175b5f0': `Thuộc tính cá nhân`,
'sf44a6b3b232c28ea': str`Thay thế giá trị hiện tại bằng ${0}`,
'sf4cd86a2f5ef2588': `Mã vạch sản phẩm`,
'sf57a61152168cc81': `Hãy giúp chúng tôi sửa lỗi phát hiện thành phần`,
'sf88b90b8ba23871c': `Trận đấu không xác định`,
'sf9aee319a006c9b4': `Thêm vào`,
'sfacbbe968fa7d773': `Tên tài sản:`,
'sfc40ea3d5d5aa6f8': `Những khoản đóng góp của quý vị tài trợ cho các hoạt động hàng ngày của hiệp hội phi lợi nhuận của chúng tôi:`,
'sfe87465d50530725': `Giá trị tương ứng`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  